<section class="header-ribbon" [ngClass]="{ minimized: minimizedRibbon }">
  <div class="header-ribbon-container">
    <ng-content></ng-content>
    <div class="header-ribbon-box header-ribbon-current-show">
      <div class="show-title">
        <span class="text-ellipsis">{{ getCurrentShowName() }}</span>
      </div>
      <span class="show-time">{{ getShowDuration("elapsed") }}</span>
      <span class="description-text">PLAYING NOW</span>
    </div>
    <div class="header-ribbon-box header-ribbon-current-show">
      <div class="show-title">
        <span class="text-ellipsis">{{ getCurrentShowName() }}</span>
      </div>
      <span class="show-time remaining">{{
        getShowDuration("remaining")
      }}</span>
      <span class="description-text">REMAINING TIME</span>
    </div>
    <div
      class="header-ribbon-box header-ribbon-skip-show skipping"
      [ngClass]="{
        skipping:
          DuringSkipToShow() ||
          !showToSkipTo ||
          (showToSkipTo && currentShow && showToSkipTo.id === currentShow.id)
      }"
    >
      <div
        class="skip-oval icon-filter-menu-top-arrow"
        (click)="skipCurrentShow()"
      ></div>
      <div class="description-text">
        <span *ngIf="!DuringSkipToShow()">SKIP TO:</span>
        <span *ngIf="DuringSkipToShow()">PROCESSING...</span>
      </div>
    </div>
    <div class="header-ribbon-box header-ribbon-current-show">
      <span class="show-title">{{ getShowDuration("next") }}</span>
      <calendar-header-dropdown
        [options]="nextShows"
        [placeholder]="'select show'"
        [textEllipsis]="200"
        [enabled]="!DuringSkipToShow()"
        (output)="setShowToSkipTo($event)"
        (clearPrerollsClicked)="clearPrerollsClicked()"
      >
      </calendar-header-dropdown>
      <!--<span class="description-text">{{skipToShowDescriptionText()}}</span>-->
    </div>
  </div>
  <div class="minimize-ribbon" (click)="minimizeRibbonToggle()">
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10">
      <path
        fill-rule="evenodd"
        d="M.724 8.948l1.048 1.051 4.993-5.002L1.772-.005.724 1.046l3.944 3.951L.724 8.948z"
      />
    </svg>
  </div>
</section>

<nav>
  <div class="left-navigation toolbar">
    <div class="calendar-view-options">
      <div
        class="button"
        [class.active]="isGridDisplay"
        (click)="onViewOptionChange('grid')"
      >
        <svg width="19" height="17">
          <path
            fill-rule="evenodd"
            d="M5 8v1H4V8h1m1-1H3v3h3V7zm3 1v1H8V8h1m1-1H7v3h3V7zm3 1v1h-1V8h1m1-1h-3v3h3V7zm-9 5v1H4v-1h1m1-1H3v3h3v-3zm3 1v1H8v-1h1m1-1H7v3h3v-3zm7.288-9H16V0h-3v2H6V0H3v2H1.712C.77 2 0 2.77 0 3.711v11.577C0 16.23.77 17 1.712 17h15.576C18.23 17 19 16.23 19 15.288V3.711C19 2.77 18.23 2 17.288 2zM14 1h1v3h-1V1zM4 1h1v3H4V1zm14 14.288a.712.712 0 0 1-.712.712H1.712A.712.712 0 0 1 1 15.288V3.711C1 3.319 1.319 3 1.712 3H3v2h3V3h7v2h3V3h1.288c.393 0 .712.319.712.711v11.577z"
          />
        </svg>
      </div>
      <div
        class="button"
        [class.active]="!isGridDisplay"
        (click)="onViewOptionChange('list')"
      >
        <svg width="18" height="12">
          <path
            fill-rule="evenodd"
            d="M3.999 11.999v-2h14v2h-14zm0-6.999h14v1.999h-14V5zm0-5.001h14v2h-14v-2zm-4 10h2v2h-2v-2zm0-4.999h2v1.999h-2V5zm0-5.001h2v2h-2v-2z"
          />
        </svg>
      </div>
    </div>

    <div (click)="now.emit()" class="now-btn" role="button">NOW</div>
    <div class="adjacent-button">
      <div (click)="prev.emit()" class="prev-btn" role="button">
        <svg width="8px" height="10px" viewBox="-2 0 12 12">
          <path
            fill-rule="evenodd"
            d="M8.001,1.364 L6.612,-0.001 L-0.001,6.500 L6.612,13.001 L8.001,11.635 L2.777,6.500 L8.001,1.364 Z"
          />
        </svg>
      </div>
      <div (click)="next.emit()" class="next-btn" role="button">
        <svg width="8px" height="10px" viewBox="-2 0 12 12">
          <path
            fill-rule="evenodd"
            d="M-0.001,1.364 L1.387,-0.001 L8.001,6.500 L1.387,13.001 L-0.001,11.635 L5.223,6.500 L-0.001,1.364 Z"
          />
        </svg>
      </div>
    </div>
    <div
      id="calPicker"
      class="calendar-title"
      (click)="showDatepicker()"
      outsideClick
      (outsideClick)="onClickedOutside()"
      (keyup.escape)="onClickedOutside()"
    >
      {{ title }}

      <icn-calendar-datepicker
        (apply)="onDatepickerApply($event)"
        (cancel)="hideDatepicker()"
      >
      </icn-calendar-datepicker>

      <div class="calendar-icon">
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="19"
          viewBox="0 0 23 19"
        >
          <g>
            <rect x="8" y="8" width="1" height="1" />
            <rect x="4" y="12" width="1" height="1" />
            <rect x="4" y="8" width="1" height="1" />
            <polygon points="5 3 5 2 5 1 4 1 4 2 4 3 4 4 5 4 5 3" />
            <polygon points="15 3 15 2 15 1 14 1 14 2 14 3 14 4 15 4 15 3" />
            <path d="M3,14H6V11H3Zm1-2H5v1H4Z" />
            <path d="M10,7H7v3h3ZM9,9H8V8H9Z" />
            <path d="M3,10H6V7H3ZM4,8H5V9H4Z" />
            <path
              d="M16,9h1v5H16l-2-3,.8-.6L16,12Zm7,3.5A6.5,6.5,0,0,1,11.8,17H1.7A1.7,1.7,0,0,1,0,15.3V3.7A1.7,1.7,0,0,1,1.7,2H3V0H6V2h7V0h3V2h1.3A1.7,1.7,0,0,1,19,3.7V6.5L20,7A6.5,6.5,0,0,1,23,12.5ZM14,4h1V1H14V4ZM4,4H5V1H4V4Zm7,12-.5-1a6.5,6.5,0,0,1,6-9l1.5.2V3.7a.7.7,0,0,0-.7-.7H16V5H13V3H6V5H3V3H1.7a.7.7,0,0,0-.7.7V15.3a.7.7,0,0,0,.7.7Zm11-3.5a5.5,5.5,0,0,0-2-4.2l-1-.7-1-.4L16.5,7a5.5,5.5,0,0,0-4.9,8l.7,1,1.1,1A5.5,5.5,0,0,0,22,12.5Z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>

  <icn-calendar-search></icn-calendar-search>
  <div
    class="customize-table-columns-container"
    [ngClass]="{ 'customize-table-columns-hidden': isGridDisplay }"
    outsideClick
    (outsideClick)="onClickedOutsideColumnsCustomization()"
    (keydown.esc)="onClickedOutsideColumnsCustomization()"
  >
    <span class="customize-table-columns-title">Columns</span>

    <span style="padding-top: 4px">
      <svg
        (click)="showColumnsCustomization()"
        height="30"
        viewBox="0 -960 960 960"
        width="30"
      >
        <path
          d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
        />
      </svg>
    </span>
    <evrideo-calendar-grid-columns-customization
      outsideClick
      (outsideClick)="onClickedOutsideColumnsCustomization()"
    ></evrideo-calendar-grid-columns-customization>
  </div>
  <div
    class="filter-sec-events-container"
    [ngClass]="{ 'filter-hidden': isGridDisplay }"
    outsideClick
    (outsideClick)="onClickedOutsideSecEventsFilter()"
    (keyup.escape)="onClickedOutsideSecEventsFilter()"
  >
    <span class="filter-sec-events-title">FILTER SEC EVENTS</span>
    <span
      class="sec-events-filter-icon"
      inlineSVG="/assets/icons/sec-events-filter.svg"
      (click)="showSecEventsFilter()"
    ></span>

    <evrideo-calendar-filter-sec-events></evrideo-calendar-filter-sec-events>
  </div>

  <section>
    <div
      class="right-navigation toolbar btn-group"
      [ngClass]="{ hidden: !isGridDisplay }"
    >
      <div
        [class.active]="activeView === 'fiveMin'"
        (click)="changeViewType('fiveMin')"
        class="btn"
        role="button"
      >
        5 MIN
      </div>
      <div
        [class.active]="activeView === 'hour'"
        (click)="changeViewType('hour')"
        class="btn"
        role="button"
      >
        HOUR
      </div>
      <div
        [class.active]="activeView === 'day'"
        (click)="changeViewType('day')"
        class="btn"
        role="button"
      >
        DAY
      </div>
      <div
        [class.active]="activeView === 'week'"
        (click)="changeViewType('week')"
        class="btn"
        role="button"
      >
        WEEK
      </div>
    </div>
  </section>
</nav>
